module.exports = __webpack_public_path__ + "static/media/checkmark.6cfaf6c8.svg";